<div class="backtop" *ngIf="isVisible" [@visibilityAnimation]>
  <div class="backtop-button block" (click)="scrollTop()"></div>
</div>
